import { Component, ElementRef, Injector, Directive, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { MonitoredTrain } from '../../models/monitored-train';
import { MonitoringAlarm } from '../../models/monitoring-alarm';

@Component({
  selector: 'app-monitored-train-summary-upgraded',
  template: require('./monitored-train-summary-upgraded.component.html'),
  styles: [require('./monitored-train-summary-upgraded.component.sass')]
})
export class MonitoredTrainSummaryUpgradedComponent extends UpgradeComponent {

  @Input() currentTrain: MonitoredTrain;
  @Input() projectId: number;
  @Input() monitoringAlarms: MonitoringAlarm[] | null;
  
  // TODO this is an angularJS component upgraded to Angular component
  constructor(elementRef: ElementRef, injector: Injector) {
    super('trainSummary', elementRef, injector);
  }
}